<template>
  <div>
    <div class="login usr">
      <h3>
        <img
          class="logo"
          src="@/img/logo.png"
          alt="インテリジェントヘルスケア ストレスチェックApp"
        />
      </h3>
      <div v-show="$store.state.common.sIsLoading" class="common-font">
        Loading...
      </div>
      <div v-show="!$store.state.common.sIsLoading" class="common-font">
        <h2 class="common-font">
          {{ $t("displayValue_Respondent.HOME_guide_questionnaire") }}
        </h2>
        <p>
          <button
            :disabled="$store.state.common.sServerProcessing"
            type="button"
            class="
              uk-button uk-button-secondary uk-width-1-1 uk-margin-small-bottom
              common-rounded
            "
            @click="doMoveToAnswerPage(1)"
          >
            {{ $t("displayValue_Respondent.HOME_btn_preparation") }}
          </button>
          <button
            :disabled="$store.state.common.sServerProcessing"
            type="button"
            class="
              uk-button uk-button-primary uk-width-1-1 uk-margin-small-bottom
              common-rounded
            "
            @click="doMoveToAnswerPage(3)"
          >
            {{ $t("displayValue_Respondent.HOME_btn_progress") }}
          </button>
          <button
            :disabled="$store.state.common.sServerProcessing"
            type="button"
            class="uk-button uk-button-danger uk-width-1-1 common-rounded"
            @click="doMoveToAnswerPage(7)"
          >
            {{ $t("displayValue_Respondent.HOME_btn_result") }}
          </button>
        </p>
        <p class="uk-text-center">
          {{ $t("displayValue_Respondent.HOME_guide_description_service1")
          }}<br />
        </p>
        <p class="uk-text-center">
          {{ $t("displayValue_Respondent.HOME_guide_description_service2")
          }}<br />
        </p>
        <p class="uk-text-center uk-text-danger">
          {{ $t("displayValue_Respondent.HOME_guide_description_service3") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import constant from "@/constant.js";

export default {
  data() {
    return {
      vComId: this.$store.state.common.sComId,
      vEmpCode: this.$store.state.common.sUserCode,
      vTblListData: [],
      vMessage: "",
    };
  },
  created() {
    // 画面読み込み中・・・
    this.$store.state.common.sIsLoading = true;
    // ログイン状態判定
    this.doAuthLoginInfo();
    if (!this.$store.state.common.sIsLogined) {
      this.$router.push("/login");
    }
    // 画面タイトル
    this.$store.commit("common/doSetScreenTitle", {
      vScreenTitle: "回答者/ホーム",
    });
    // DB参照処理
    if (this.vComId) {
      this.vMessage = "";
      this.$axios
        .get(constant.cServerRoute.respondent.home, {
          params: {
            pComId: this.vComId,
            pEmpCode: this.vEmpCode,
          },
        })
        .then(
          function (response) {
            console.log(response);
            // 実施管理データ参照処理判定
            if (
              response.data.return_result ==
              constant.cServerReturnResult.success
            ) {
              // 実施管理データを保持する
              if (response.data.return_data) {
                this.vTblListData = response.data.return_data;
              }
            } else {
              this.vMessage = response.data.return_message;
            }
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error);
          this.vMessage = error;
        });
    }
  },
  // 画面読み込み終わった？
  mounted() {
    this.$store.state.common.sIsLoading = false;
  },
  methods: {
    // 回答ページへ遷移する
    doMoveToAnswerPage(scStatus) {
      // 実施IDを遷移先の回答ページへ渡したい
      // ボタン制御
      this.$store.commit("common/doStartServerProcess");
      this.$store.state.answer.sScStatusForScreen = scStatus;
      if (this.$store.state.answer.sScStatusForScreen == 7) {
        this.$router.push("/respondent-results");
      } else {
        this.$router.push("/respondent-answer");
      }
      // ボタン制御
      // this.$store.commit('common/doEndServerProcess');
    },
    // ID,パスワード照合
    doAuthLoginInfo() {
      if (sessionStorage.getItem("storageId")) {
        let createHash = require("sha256-uint8array").createHash;
        let tmp = createHash()
          .update(sessionStorage.getItem("storagePw"))
          .digest("hex");
        this.$axios
          .post(constant.cServerRoute.common.login, {
            alias_id: sessionStorage.getItem("storageAliasId"),
            pLoginId: sessionStorage.getItem("storageId"),
            pLoginPw: tmp,
          })
          .then(
            function (response) {
              console.log(response);
              if (
                response.data.return_result !=
                constant.cServerReturnResult.success
              ) {
                this.$store.state.common.sIsLogined = false;
              }
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error);
            this.$store.state.common.sIsLogined = false;
          });
      }
    },
  },
};
</script>
